import React, { FC } from "react";
import { Svg } from "@natera/material/lib/svg";
import { HEAP_EVENTS } from "@app/provider/types";
import { usePostBillHeapEvent } from "@app/postBill/hooks";

import arrowTopRightSVG from "@assets/svg/icons/arrow-top-right.svg";

import "./linkActionCard.scss";

interface LinkActionCardProps {
  title: string;
  body: string;
  href: string;
  heapEvent?: HEAP_EVENTS;
}

const LinkActionCard: FC<LinkActionCardProps> = ({
  title,
  body,
  href,
  heapEvent,
}) => {
  const { trackPostBillHeapEvent } = usePostBillHeapEvent();

  const handleClickEvent = () => {
    heapEvent && trackPostBillHeapEvent({ eventKey: heapEvent });
  };

  return (
    <a
      className="link-action-card"
      href={href}
      onClick={handleClickEvent}
      key="contactUs"
      target="_blank"
      rel="noreferrer"
    >
      <div className="link-action-card__content">
        <span className="link-action-card__content__title">{title}</span>
        <span className="link-action-card__content__body">{body}</span>
      </div>
      <div className="link-action-card__icon">
        <Svg content={arrowTopRightSVG} />
      </div>
    </a>
  );
};

export default LinkActionCard;
